import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import PropTypes from "prop-types";
import React from "react";

const Sortable = ({ children, id }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style}>
      {children &&
        React.cloneElement(children, {
          dndProperties: { ...listeners, ...attributes },
        })}
    </div>
  );
};

Sortable.propTypes = {
  id: PropTypes.string.isRequired,
  children: PropTypes.element,
};

export default Sortable;
